module.exports = __webpack_public_path__ + "static/media/renpy-dialogue-disabled-buttons.73d5fcf6.jpg";